import { InputWrapper, Input, useValidator } from "nystem-components";
import app from "nystem";
import validate from "./validate";

const FloatInput = ({ model, view, focus, setValue, value }) => {
  const [error, setValidated] = useValidator({ view, validate, value, model });
  const {
    disabled,
    length,
    text,
    classNameInput = ["w-full"],
  } = model;

  return (
    <InputWrapper
      model={{ ...model, classNameInput: "relative flex w-full" }}
      error={error}
    >
      <Input
        placeholder={app.t(text)}
        className={classNameInput}
        value={!value && value !== 0 ? "" : value}
        maxLength={length}
        onChange={(value) => {
          const val = value.replace(/[^0-9.-]/gim, "");
          setValue(val ? parseFloat(val) : undefined);
        }}
        disabled={disabled}
        type="text"
        focus={model.focus || focus}
        onBlur={() => setValidated(true)}
        selectAllOnFocus={model.selectAllOnFocus}
      />
    </InputWrapper>
  );
};
export default FloatInput;
